import { inject } from '@angular/core';
import { FinanceService } from '@core/services/finance.service';
import { ResolveFn } from '@angular/router';

export const pendingDisbursementsResolver: ResolveFn<void> = async () => {
  await inject(FinanceService).setPendingDisbursements();
}
